import { organizationDetailSchema, type OrganizationInput } from '@fluxus/shared';
import { useQueryClient } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link, useNavigate } from 'react-router';
import { toast } from 'sonner';
import { PageContainer, PageHeader } from '@/components/layout/PageHeader';
import { OrganizationForm } from '@/features/organizations/OrganizationForm';
import { useAuth } from '@/lib/auth/session';

/** Nova empresa cliente (Central de Empresas › criar empresa — PRD §11.2). */
export function NovaEmpresaPage() {
  const { client } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  async function create(input: OrganizationInput) {
    const org = await client.request('/organizations', {
      method: 'POST',
      body: input,
      schema: organizationDetailSchema,
    });
    await queryClient.invalidateQueries({ queryKey: ['organizations', 'central'] });
    toast.success(`Empresa ${org.name} criada`, {
      description: 'Os perfis padrão já foram criados. Abra o projeto BSC e envie o logotipo.',
    });
    await navigate(`/empresas/${org.id}`, { replace: true });
  }

  return (
    <PageContainer className="max-w-2xl">
      <Link
        to="/empresas"
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" aria-hidden />
        Central de Empresas
      </Link>
      <PageHeader
        className="mt-4"
        title="Nova empresa"
        description="Cadastre a empresa cliente. Depois você abre o projeto BSC, envia o logotipo e convida os usuários."
      />
      <div className="mt-6 rounded-lg border border-border bg-surface p-5">
        <OrganizationForm
          submitLabel="Criar empresa"
          onSubmit={create}
          onCancel={() => void navigate('/empresas')}
        />
      </div>
    </PageContainer>
  );
}
